import httpClient from "./httpClient";

const prefix = "/branch-schedule";

/* templates */
export async function readTemplate(id: number) {
  return (await httpClient.get(`${prefix}/templates/${id}`)).data;
}

export async function readTemplates() {
  return (await httpClient.get(`${prefix}/templates`)).data;
}

export async function paginateTemplates(query: string) {
  return (await httpClient.get(`${prefix}/templates/paginate?${query}`)).data;
}

export async function saveTemplates(name: string) {
  return (await httpClient.post(`${prefix}/templates`, { name })).data;
}

export async function updateTemplates(id: number, name: string) {
  return (await httpClient.patch(`${prefix}/templates/${id}`, { name })).data;
}

export async function deleteTemplates(id: number) {
  return (await httpClient.delete(`${prefix}/templates/${id}`)).data;
}

/* positions */
export async function readPositions() {
  return (await httpClient.get(`${prefix}/positions`)).data;
}

export async function readPositionsByBranch(id: number) {
  return (await httpClient.get(`${prefix}/positions/branch/${id}`)).data;
}

export async function readPositionsByBranchFiltered(id: number) {
  return (await httpClient.get(`${prefix}/positions/branchfiltered/${id}`))
    .data;
}

export async function readPositionsByBranchAndShift(id: number, shift: string) {
  return (await httpClient.get(`${prefix}/positions/branch/${id}/${shift}`))
    .data;
}

export async function readUniquePositionNamesByBranch(id: number) {
  return (await httpClient.get(`${prefix}/positions/unique-names/branch/${id}`))
    .data;
}

export async function savePositions(data: any) {
  return (await httpClient.post(`${prefix}/template-positions`, data)).data;
}

export async function updatePositions(id: number, data: any) {
  return (await httpClient.patch(`${prefix}/positions/${id}`, data)).data;
}

export async function deletePositions(id: number) {
  return (await httpClient.delete(`${prefix}/positions/${id}`)).data;
}

/* schedules */
export async function updateAssistance(id: number, data: any) {
  return (await httpClient.patch(`${prefix}/schedules/${id}`, data)).data;
}

export async function updateReplacement(id: number, data: any) {
  return (await httpClient.patch(`${prefix}/schedules/replacement/${id}`, data))
    .data;
}

export async function readSchedules() {
  return (await httpClient.get(`${prefix}/schedules`)).data;
}

export async function readSchedulesByBranchAndWeek(id: number, week: string) {
  return (await httpClient.get(`${prefix}/schedules/branch/${id}/week/${week}`))
    .data;
}

export async function readSchedulesByBranchShiftWeekDay(
  id: number,
  shift: string,
  week: string,
  dayOfWeek: string,
  exactDate?: string,
) {
  const params = exactDate ? { exactDate } : undefined;
  return (
    await httpClient.get(
      `${prefix}/schedules/specific/${id}/${shift}/${week}/${dayOfWeek}`,
      { params },
    )
  ).data;
}
export async function readSchedulesOrganigram(id: number) {
  return (await httpClient.get(`${prefix}/schedules/organigram/${id}`)).data;
}
export async function readHistoryByBranchAndShiftWeekDay(
  id: number,
  shift: string,
  week: string,
  dayOfWeek: string
) {
  return (
    await httpClient.get(
      `${prefix}/schedulesHistory/specific/${id}/${shift}/${week}/${dayOfWeek}`
    )
  ).data;
}

export async function findByExactDateAndPartner(
  exactDate: string,
  partnerId: number
) {
  return (
    await httpClient.get(
      `${prefix}/schedules/assistance/${exactDate}/${partnerId}`
    )
  ).data;
}

export async function saveSchedule(data: any) {
  return (await httpClient.post(`/check-schedule/schedules`, data)).data;
}

export async function updateSchedules(id: number) {
  return (await httpClient.patch(`${prefix}/schedules/${id}`)).data;
}

export async function deleteSchedules(id: number) {
  return (await httpClient.delete(`${prefix}/schedules/${id}`)).data;
}

export async function findByExactDateAndBranch(
  exactDate: string,
  branchId: number
) {
  return (
    await httpClient.get(
      `${prefix}/schedules/exact-date/${exactDate}/branch/${branchId}`
    )
  ).data;
}

export async function findNotAssistance(query: string) {
  return (await httpClient.get(`${prefix}/schedules/not-assistance?${query}`))
    .data;
}

export async function findAllSchedulesByBranch(id: number, query: string) {
  return (await httpClient.get(`${prefix}/schedules/branch/${id}?${query}`))
    .data;
}

/* Hours */
export async function createHours(data: any) {
  return (await httpClient.post(`${prefix}/hours`, data)).data;
}

export async function readClockHoursByBranch(id: number) {
  return (await httpClient.get(`${prefix}/hours/clock/branch/${id}`)).data;
}

export async function readHoursByBranch(id: number) {
  return (await httpClient.get(`${prefix}/hours/branch/${id}`)).data;
}

export async function createFullDayHours(data: any) {
  return (await httpClient.post(`${prefix}/hours/full-day`, data)).data;
}

export async function readFullDayHoursByBranch(id: number) {
  return (await httpClient.get(`${prefix}/hours/full-day/branch/${id}`)).data;
}

export async function findPartnerSchedule(id: number, query: string) {
  return (await httpClient.get(`${prefix}/partnerSchedule/${id}?${query}`))
    .data;
}

/* History */
export async function readHistoryByBranch(id: number) {
  return (await httpClient.get(`${prefix}/history/branch/${id}`)).data;
}

export async function createHistory(data: any) {
  return (await httpClient.post(`${prefix}/history`, data)).data;
}

/* Incidents */
export async function readIncidentsByBranch(
  branch: number,
  date: string,
  type: string
) {
  return (
    await httpClient.get(
      `${prefix}/incidents-schedule?branch=${branch}&date=${date}&type=${type}`
    )
  ).data;
}

export async function countIncidentsByBranch(branch: number, date: string) {
  return (
    await httpClient.get(
      // `${prefix }/count-incidents-schedule?branch=${branch}&date=${date}`
      `/assistance-check/count-incidents-schedule?branch=${branch}&date=${date}`
    )
  ).data;
}

export async function findPartnersByBranchAndCompleteWeek(
  branchId: number,
  exactDate: string
) {
  return (
    await httpClient.get(`${prefix}/partner-schedule/${branchId}/${exactDate}`)
  ).data;
}

export async function findPartnersWithMultipleFunctions(
  branchId: number,
  exactDate: string
) {
  return (
    await httpClient.get(
      `${prefix}/partner-multiple-functions/${branchId}/${exactDate}`
    )
  ).data;
}

export async function findPartnersWithMultipleShifts(
  branchId: number,
  exactDate: string
) {
  return (
    await httpClient.get(
      `${prefix}/partner-multiple-shifts/${branchId}/${exactDate}`
    )
  ).data;
}

export async function findPartnersAllWeek(branchId: number, exactDate: string) {
  return (
    await httpClient.get(`${prefix}/partner-all-week/${branchId}/${exactDate}`)
  ).data;
}

export async function findPartnersRestDay(
  branch: number,
  partner: number,
  start: string,
  end: string
) {
  return (
    await httpClient.get(
      `${prefix}/partners-rest-day?branch=${branch}&partner=${partner}&start=${start}&end=${end}`
    )
  ).data;
}
export async function findPartnersWithSingleWorkDay(
  branchId: number,
  exactDate: string
) {
  return (
    await httpClient.get(
      `${prefix}/partner-single-work-day/${branchId}/${exactDate}`
    )
  ).data;
}

export async function saveIncident(id: number, data: {}) {
  return (await httpClient.patch(`${prefix}/incidents-schedule/${id}`, data))
    .data;
}

export async function getScheduleEditConfig(branchId: number) {
  return (await httpClient.get(`${prefix}/edit-config/branch/${branchId}`))
    .data;
}

export async function updateScheduleEditConfig(
  branchId: number,
  data: {
    enabled: boolean;
    durationMinutes?: number;
  }
) {
  return (
    await httpClient.patch(`${prefix}/edit-config/branch/${branchId}`, data)
  ).data;
}

export async function getOperationalRiskReport(query: string = "") {
  return (await httpClient.get(`${prefix}/risk-report?${query}`)).data;
}

/* reporte de faltas */
export async function getFaltasReport(branchId: number, date: string, shift: string) {
  return (
    await httpClient.get(
      `${prefix}/report-faltas/${branchId}?date=${encodeURIComponent(date)}&shift=${encodeURIComponent(shift)}`
    )
  ).data;
}

export async function sendFaltasReportWhatsApp(
  branchId: number,
  date: string,
  shift: string,
  phoneNumber?: string
) {
  const params = new URLSearchParams({ date, shift });
  return (
    await httpClient.post(
      `${prefix}/report-faltas/${branchId}/send-whatsapp?${params}`,
      phoneNumber ? { phoneNumber } : {}
    )
  ).data;
}

/** Reporte consolidado: todas las sucursales en un solo PDF por turno */
export async function getFaltasReportConsolidado(date: string, shift: string) {
  const params = new URLSearchParams({ date, shift });
  return (await httpClient.get(`${prefix}/report-faltas/consolidado?${params}`))
    .data;
}

export async function downloadFaltasReportConsolidadoPdf(
  date: string,
  shift: string
): Promise<{ blob: Blob; filename: string }> {
  const params = new URLSearchParams({ date, shift });
  const response = await httpClient.get(
    `${prefix}/report-faltas/consolidado/pdf?${params}`,
    { responseType: "blob" }
  );
  const disposition = response.headers?.["content-disposition"] || "";
  const filenameMatch = disposition.match(/filename="?([^"]+)"?/i);
  const filename = filenameMatch?.[1] || `Reporte-faltas-consolidado-${date}-${shift}.pdf`;

  return { blob: response.data, filename };
}

export async function sendFaltasReportConsolidadoWhatsApp(
  date: string,
  shift: string,
  payload?: { phoneNumber?: string; phoneNumbers?: string[] }
) {
  const params = new URLSearchParams({ date, shift });
  const body =
    payload?.phoneNumbers?.length || payload?.phoneNumber ? payload : {};
  return (
    await httpClient.post(
      `${prefix}/report-faltas/consolidado/send-whatsapp?${params}`,
      body
    )
  ).data;
}
